import React, { FC } from 'react';
import { Breadcrumbs as MUIBreadcrumbs, makeStyles, Theme } from '@material-ui/core';
import { IBreadcrumb } from 'common/interfaces/common';
import Breadcrumb from './Breadcrumb';

const useStyles = makeStyles((theme: Theme) => ({
  breadcrumbs: {
    color: theme.palette.text.secondary,
    marginBottom: '8px',
  },
}));

interface IBreadcrumbs {
  breadcrumbs: IBreadcrumb[];
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ breadcrumbs }) => {
  const classes = useStyles();
  const breadcrumbList: IBreadcrumb[] = [...breadcrumbs];
  const lastItem = breadcrumbList.pop();

  return (
    <MUIBreadcrumbs
      className={`breadcrumbs ${classes.breadcrumbs}`}
      separator="/"
      aria-label="breadcrumb"
    >
      {breadcrumbList.map(breadcrumb => {
        return <Breadcrumb key={breadcrumb.path} breadcrumb={breadcrumb} />;
      })}

      {lastItem ? <Breadcrumb breadcrumb={lastItem} inactive /> : null}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
